import type {
  dealerCodeDataIncoming,
  dealerCodeDataResponse
} from "./interface";

export const mockServiceAccountIdDealerCodePairsData: dealerCodeDataIncoming[] =
  [
    {
      accountId: "hmausa",
      dealerCode: "TN024",
      dealerCodeType: "activation",
      id: "3f88f3330a2500dc78f23ea7d1ce9447",
      userId: "system",
      actingAsUserId: "system",
      audit: {
        created: "2024-08-06T00:06:55.000+00:00",
        createdBy: "system-setup",
        lastModified: "2024-08-06T00:06:55.000+00:00",
        lastModifiedBy: "system-setup"
      }
    },
    {
      accountId: "alliancenissan",
      dealerCode: "alliancenissan",
      dealerCodeType: "activation",
      id: "3f88f3330a2500dc78f23ea7d1ce9447",
      userId: "system",
      actingAsUserId: "system",
      audit: {
        created: "2024-08-06T00:06:55.000+00:00",
        createdBy: "system-setup",
        lastModified: "2024-08-06T00:06:55.000+00:00",
        lastModifiedBy: "system-setup"
      }
    }
  ];

export const mockServiceAccountIdDealerCodePairsResponse = {
  statusCode: 200,
  body: mockServiceAccountIdDealerCodePairsData
};

export const mockedGetDealerCodeTypesByAccountIdUrl = {
  statusCode: 200,
  body: JSON.stringify([
    {
      id: "1",
      dealerCode: "ABC",
      dealerCodeType: "Z"
    },
    {
      id: "2",
      dealerCode: "DEF",
      dealerCodeType: "A"
    }
  ])
};
export const handlerResponse: dealerCodeDataResponse = {
  dealerCodeData: [
    {
      id: "3f88f3330a2500dc78f23ea7d1ce9447",
      dealerCode: "TN024",
      accountId: "hmausa"
    },
    {
      id: "3f88f3330a2500dc78f23ea7d1ce9447",
      dealerCode: "alliancenissan",
      accountId: "alliancenissan"
    }
  ],
  currentPage: 0,
  totalPages: 1,
  totalElements: 2
};

export const ccsPutRequestResponse = {
  statusCode: 200,
  body: JSON.stringify({
    id: "123",
    accountId: "accountId",
    dealerCode: "dealerCode",
    dealerCodeType: "dealerCodeType"
  })
};

export const cc9GetRequestResponse = {
  statusCode: 200,
  body: JSON.stringify([
    "saab-ddc",
    "soa-mtl",
    "ar",
    "nci",
    "echoparkmarketid",
    "contact-at-once",
    "bmw",
    "elead",
    "tcre-agent",
    "soazone",
    "simsstoreid",
    "vw",
    "sonic-callsource",
    "fmc-ddc",
    "mbz",
    "gmcabac",
    "mitsubishi-export",
    "fdca",
    "nna",
    "soa-ddc",
    "gcb-mx",
    "nissanleads",
    "fiat-temp",
    "hertzrouteone",
    "gm-dealer-ca",
    "boa",
    "adp-sonic",
    "kia",
    "ram",
    "bmw_cpo_tier2",
    "activation",
    "tcshortcode",
    "gm",
    "volvo-partner-id",
    "gsm",
    "gm-backlink-ca",
    "mercedes-export",
    "suburban",
    "penairfcu",
    "autocheck",
    "gmca",
    "lexus",
    "soadistrict",
    "hooklogic",
    "cllc",
    "ove",
    "sdis_toyota",
    "cci",
    "toyota_region",
    "bmw-export",
    "vwdr",
    "gm-carbravo",
    "dealer-socket",
    "aoadistrict",
    "mitsuud",
    "aoaddc-cdc",
    "cllcpr",
    "trademotion",
    "hyundai_dma_cd",
    "fiat-ddc",
    "dmi",
    "flowautomotive",
    "scion_region",
    "openlane",
    "gm-homenet",
    "mazda",
    "genesis_region",
    "hondaoem",
    "clldaachrysler",
    "hyundai",
    "toyota_set",
    "fordregion",
    "mazda-export",
    "mitsubishi",
    "bmw_cpo",
    "jeep",
    "bmw_location",
    "fmc",
    "clldaajeep",
    "toyota_tcom",
    "clldaadodge",
    "toyota_bat",
    "jag-export",
    "hertz",
    "honda",
    "genesis_adi",
    "ryantech-sonic",
    "hyundai_adi",
    "hyundai_district",
    "volvo",
    "jag-cpo",
    "fd",
    "route-one",
    "genesisdwcp",
    "toyota_tda",
    "hyundaictb",
    "ford-model-e",
    "offerlogix",
    "bmw_region",
    "cvi-ddc-entityid-map",
    "gst",
    "gm-acc-ca",
    "fdregion",
    "hyundai_region",
    "fiat",
    "nissanservice",
    "lexus-lda",
    "rmau",
    "kiadmg",
    "tc",
    "arca",
    "toyota_pooling",
    "saab",
    "soaregion",
    "lr",
    "aoa-ddc",
    "langley",
    "autonation",
    "soa",
    "kiadmggroup",
    "sneregion",
    "sonic",
    "kia-reporting",
    "suzuki",
    "volvo-ddc",
    "modernautomotive",
    "gm-chipered-ca",
    "lexus-geo-key",
    "scion",
    "vw-export",
    "at-kbb",
    "mmd",
    "fca-export",
    "w2w",
    "cvi_ddc_account_mapping",
    "mini-export",
    "audicanada",
    "fiatca",
    "hondaadvdealer",
    "volvo_cbv_exclusion",
    "sne",
    "lender",
    "excluded_jeep_accounts",
    "genesis",
    "volvo_cle_vinless",
    "fiatpr",
    "genesis_district",
    "driverside",
    "vw-daa",
    "adw",
    "snedistrict",
    "echoparkstoreid",
    "porsche",
    "cllc-ddc",
    "mini",
    "jag",
    "hertzrouteonefinance",
    "vcna",
    "gm-export",
    "dtdms",
    "subaru-export",
    "avis",
    "an-hyperion",
    "fcamx",
    "aoa-export",
    "dt-dr-profile",
    "fca_vin_incentives",
    "lexus-export",
    "vinsolutions-ddc",
    "unique_svoc_to_sa",
    "cllcbc",
    "auxiliary_options",
    "lhm",
    "maserati",
    "cci-ddc",
    "toyota",
    "ais",
    "nissanoem",
    "simsmarketid",
    "kia_inventory_export",
    "lr-export",
    "fca_ca-export",
    "cllcdistrict",
    "lithia",
    "toyota-export",
    "dealertrack-post",
    "aoa",
    "tcre-broker",
    "affiliate_promotions",
    "sdis_lexus",
    "toyota_smartpath",
    "hyundaidwcp",
    "au"
  ])
};

export const mockAllDealerCodeTypes: string[] = [
  "activation",
  "adp-sonic",
  "adw",
  "affiliate_promotions",
  "ais",
  "an-hyperion",
  "aoa",
  "aoa-ddc",
  "aoa-export",
  "aoaddc-cdc",
  "aoadistrict",
  "ar",
  "arca",
  "at-kbb",
  "au",
  "audicanada",
  "autocheck",
  "autonation",
  "auxiliary_options",
  "avis",
  "bmw",
  "bmw-export",
  "bmw_cpo",
  "bmw_cpo_tier2",
  "bmw_location",
  "bmw_region",
  "boa",
  "cci",
  "cci-ddc",
  "cllc",
  "cllc-ddc",
  "cllcbc",
  "cllcdistrict",
  "cllcpr",
  "clldaachrysler",
  "clldaadodge",
  "clldaajeep",
  "contact-at-once",
  "cvi-ddc-entityid-map",
  "cvi_ddc_account_mapping",
  "dealer-socket",
  "dealertrack-post",
  "dmi",
  "driverside",
  "dt-dr-profile",
  "dtdms",
  "echoparkmarketid",
  "echoparkstoreid",
  "elead",
  "excluded_jeep_accounts",
  "fca-export",
  "fca_ca-export",
  "fca_vin_incentives",
  "fcamx",
  "fd",
  "fdca",
  "fdregion",
  "fiat",
  "fiat-ddc",
  "fiat-temp",
  "fiatca",
  "fiatpr",
  "flowautomotive",
  "fmc",
  "fmc-ddc",
  "ford-model-e",
  "fordregion",
  "gcb-mx",
  "genesis",
  "genesis_adi",
  "genesis_district",
  "genesis_region",
  "genesisdwcp",
  "gm",
  "gm-acc-ca",
  "gm-backlink-ca",
  "gm-carbravo",
  "gm-chipered-ca",
  "gm-dealer-ca",
  "gm-export",
  "gm-homenet",
  "gmca",
  "gmcabac",
  "gsm",
  "gst",
  "hertz",
  "hertzrouteone",
  "hertzrouteonefinance",
  "honda",
  "hondaadvdealer",
  "hondaoem",
  "hooklogic",
  "hyundai",
  "hyundai_adi",
  "hyundai_district",
  "hyundai_dma_cd",
  "hyundai_region",
  "hyundaictb",
  "hyundaidwcp",
  "jag",
  "jag-cpo",
  "jag-export",
  "jeep",
  "kia",
  "kia-reporting",
  "kia_inventory_export",
  "kiadmg",
  "kiadmggroup",
  "langley",
  "lender",
  "lexus",
  "lexus-export",
  "lexus-geo-key",
  "lexus-lda",
  "lhm",
  "lithia",
  "lr",
  "lr-export",
  "maserati",
  "mazda",
  "mazda-export",
  "mbz",
  "mercedes-export",
  "mini",
  "mini-export",
  "mitsubishi",
  "mitsubishi-export",
  "mitsuud",
  "mmd",
  "modernautomotive",
  "nci",
  "nissanleads",
  "nissanoem",
  "nissanservice",
  "nna",
  "offerlogix",
  "openlane",
  "ove",
  "penairfcu",
  "porsche",
  "ram",
  "rmau",
  "route-one",
  "ryantech-sonic",
  "saab",
  "saab-ddc",
  "scion",
  "scion_region",
  "sdis_lexus",
  "sdis_toyota",
  "simsmarketid",
  "simsstoreid",
  "sne",
  "snedistrict",
  "sneregion",
  "soa",
  "soa-ddc",
  "soa-mtl",
  "soadistrict",
  "soaregion",
  "soazone",
  "sonic",
  "sonic-callsource",
  "subaru-export",
  "suburban",
  "suzuki",
  "tc",
  "tcre-agent",
  "tcre-broker",
  "tcshortcode",
  "toyota",
  "toyota-export",
  "toyota_bat",
  "toyota_pooling",
  "toyota_region",
  "toyota_set",
  "toyota_smartpath",
  "toyota_tcom",
  "toyota_tda",
  "trademotion",
  "unique_svoc_to_sa",
  "vcna",
  "vinsolutions-ddc",
  "volvo",
  "volvo-ddc",
  "volvo-partner-id",
  "volvo_cbv_exclusion",
  "volvo_cle_vinless",
  "vw",
  "vw-daa",
  "vw-export",
  "vwdr",
  "w2w"
];

export const mock500Response = {
  statusCode: 500,
  body: "Internal Server Error"
};

export const mockActivationDealerCodes = [
  {
    id: "2c96819f9277a9ba01927c63c0f10016",
    accountId: "futuredemodealer",
    dealerCode: "123",
    dealerCodeType: "activation",
    userId: "mjdell",
    actingAsUserId: "mjdell",
    audit: {
      created: "2024-10-11T16:22:45.000+00:00",
      createdBy: "mjdell",
      lastModified: "2024-10-11T16:22:45.000+00:00",
      lastModifiedBy: "mjdell"
    }
  },
  {
    id: "2c9683ed92e3d1630192f7ba6f1c00e1",
    accountId: "nalleyinfinitimarietta",
    dealerCode: "11042401",
    dealerCodeType: "activation",
    userId: "rafrazier",
    actingAsUserId: "rafrazier",
    audit: {
      created: "2024-11-04T15:10:43.000+00:00",
      createdBy: "rafrazier",
      lastModified: "2024-11-04T15:10:43.000+00:00",
      lastModifiedBy: "rafrazier"
    }
  },
  {
    id: "3f88f3330a2500dc78f23ea7d1ce9447",
    accountId: "hmausa",
    dealerCode: "TN024",
    dealerCodeType: "activation",
    userId: "system",
    actingAsUserId: "system",
    audit: {
      created: "2024-08-06T00:06:55.000+00:00",
      createdBy: "system-setup",
      lastModified: "2024-08-06T00:06:55.000+00:00",
      lastModifiedBy: "system-setup"
    }
  }
];
